import { Controller } from "@hotwired/stimulus"

// 구매로 방금 담긴 줄의 수량 칸에 커서를 놓는다 (구 웹수발주와 같은 흐름).
//
// 목록에서 구매 → 바로 숫자 입력 → 칸을 벗어나면 자동 저장. 값 전체를 선택해 두어
// 기본값 1 을 지우지 않고 바로 덮어쓸 수 있게 한다.
//
// 장바구니가 목록 옆에 붙는 넓은 화면(lg)에서만 한다. 휴대폰에서는 장바구니가
// 목록 아래에 있어 커서를 옮기면 화면이 아래로 튀고 키보드가 올라와, 목록에서
// 다음 품목을 고르던 흐름이 끊긴다.
const SIDE_BY_SIDE = "(min-width: 1024px)"

export default class extends Controller<HTMLInputElement> {
  connect(): void {
    if (!window.matchMedia(SIDE_BY_SIDE).matches) return

    // 스트림이 패널을 갈아 끼운 직후라, 그려진 다음 틀에서 옮긴다.
    requestAnimationFrame(() => {
      if (!this.element.isConnected) return

      this.element.scrollIntoView({ block: "nearest" })
      this.element.focus({ preventScroll: true })
      this.element.select()
    })
  }
}
